@if (currentDocRole != docRole.SupplierPreparation) {
  <div class="aside-header">
    <dw-ui-kpi-grid>
      <div>
        <div class="row">
          <dw-ui-kpi
            [value]="entity?.totalAmount ?? 0 | currency: '€'"
            [legend]="'Doc::CustomerInvoice:AmountHTVA' | abpLocalization"
            class="col"
          ></dw-ui-kpi>
          <dw-ui-kpi
            [value]="
              (entity?.totalAmountVatIncluded ?? 0 | currency: '€') +
              (entity?.financialDiscount != null ? '*' : '')
            "
            [legend]="'Doc::CustomerInvoice:AmountTVA' | abpLocalization"
            class="col"
          ></dw-ui-kpi>
        </div>
        @if (currentDocRole == docRole.CustomerSalesPurchase) {
          <div class="row">
            <dw-ui-kpi
              [value]="entity?.totalDeposit ?? 0 | currency: '€'"
              [legend]="'Doc::DepositAmount' | abpLocalization"
              class="col kpi-secondary"
            ></dw-ui-kpi>
            <dw-ui-kpi
              [value]="entity?.balanceDue ?? 0 | currency: '€'"
              [legend]="'Doc::BalanceDue' | abpLocalization"
              class="col kpi-secondary"
            ></dw-ui-kpi>
          </div>
        }
        @if (
          currentDocRole == docRole.CustomerQuote ||
          currentDocRole == docRole.CustomerSalesPurchase ||
          currentDocRole == docRole.SupplierDeliveryNote
        ) {
          <div class="row">
            <dw-ui-kpi
              [value]="
                (entity?.totalWeightWithoutOptional ?? 0
                  | number: currentCompanyStore.weightDecimalsFormat()) +
                ' ' +
                (currentCompanyStore.weightUnit() == weightUnits.Kilograms ? 'kg' : 'g')
              "
              [legend]="'Doc::CustomerInvoice:TotalWeight' | abpLocalization"
              class="col"
            ></dw-ui-kpi>
          </div>
        } @else if (
          currentDocRole == docRole.CustomerCreditNote ||
          currentDocRole == docRole.CustomerInvoice ||
          currentDocRole == docRole.CustomerReturnNote ||
          currentDocRole == docRole.CustomerDeliveryNote
        ) {
          @let remainingAmount = (remainingAmount$ | async) ?? 0;

          @if (
            currentDocRole == docRole.CustomerCreditNote ||
            currentDocRole == docRole.CustomerInvoice
          ) {
            <dw-ui-kpi
              [value]="remainingAmount | currency: '€'"
              [legend]="'Doc::CustomerInvoice:RemainingAmount' | abpLocalization"
              [colorClass]="remainingAmount > 0 && isDueDateExpired ? 'kpi-alert' : ''"
            ></dw-ui-kpi>
          } @else if (
            (currentDocRole == docRole.CustomerReturnNote ||
              currentDocRole == docRole.CustomerDeliveryNote) &&
            remainingAmount !== undefined
          ) {
            <dw-ui-kpi
              [value]="remainingAmount | currency: '€'"
              [legend]="'Doc::CustomerInvoice:RemainingAmount' | abpLocalization"
              [colorClass]="remainingAmount > 0 && isDueDateExpired ? 'kpi-alert' : ''"
            ></dw-ui-kpi>
          }
        }
      </div>
    </dw-ui-kpi-grid>
  </div>
}

@if (entity != null) {
  <div class="aside-body">
    <div class="thirdparty-infos">
      <h4 class="text-primary fw-bold my-1 title">
        <a (click)="redirectToThirdParty(thirdParty.id)" style="cursor: pointer">
          {{ thirdParty?.name }}
        </a>
      </h4>
      <div class="audit-container mb-3">
        @if (customerProject != null) {
          <span
            class="ui-tag document-tag badge rounded-pill fw-normal mb-1"
            (click)="navigateToCustomerProject()"
          >
            <i class="digi-out-directory text-primary"></i>
            {{ 'Doc::CustomerProject' | abpLocalization }}: {{ customerProject.displayNumber }}
          </span>
        }
        <core-informations-audited-entity [auditedEntity]="entity">
        </core-informations-audited-entity>
      </div>
      @if (entity?.thirdPartyFinancialScore != null) {
        <div class="financial-score">
          <contact-financial-score-image
            [score]="entity?.thirdPartyFinancialScore"
            [imageName]="entity?.thirdPartyFinancialScoreImage"
            [financialInfos]="financialInfos"
            [creditLimit]="entity?.thirdPartyFinancialCreditLimit"
            [creditLimitInfo]="entity?.thirdPartyFinancialCreditLimitInfo"
            [url]="entity?.thirdPartyFinancialURL"
            [warnings]="entity?.thirdPartyFinancialWarnings"
            [judicialAgreements]="entity?.thirdPartyFinancialJudicialAgreements"
          ></contact-financial-score-image>
        </div>
      }
    </div>
    <div>
      @if (thirdPartyContact$ | async) {
        <div class="my-2">
          <i class="digi-out-user me-1"></i>
          {{ thirdPartyContact$ | async }}
        </div>
      }
      @if (contactEmail) {
        <div class="my-2">
          <i class="digi-out-email me-1"></i>
          {{ contactEmail }}
        </div>
      }
      @if (contactPhone) {
        <div class="my-2">
          <i class="digi-out-phone me-1"></i>
          {{ contactPhone }}
        </div>
      }
      @if (customerAddress) {
        <div class="my-2">
          <i class="digi-out-pin me-1"></i>
          {{ customerAddress }}
        </div>
      }
      @if (deliveryAddressForm()) {
        <div class="my-2">
          <document-icon-address
            [addressFrom]="deliveryAddressForm().addressFrom"
            [docRole]="currentDocRole"
            class="me-1"
          ></document-icon-address>
          {{ deliveryAddressLabel() }}
        </div>
      }

      @if (
        currentDocRole != docRole.SupplierPurchaseOrder &&
        currentDocRole != docRole.SupplierDeliveryNote
      ) {
        <div class="container-amount my-1 py-1 px-2 rounded-2">
          <contact-accounting-balance-summary-component
            [accountingCustomerOutstandingDto]="accountingCustomerOutstandingDto"
            [entity]="thirdParty"
            [creditLimit]="creditLimit"
          ></contact-accounting-balance-summary-component>
          @if (
            currentDocRole == docRole.CustomerQuote ||
            currentDocRole == docRole.CustomerInvoice ||
            currentDocRole == docRole.CustomerReturnNote ||
            currentDocRole == docRole.SupplierQuote ||
            currentDocRole == docRole.CustomerSalesPurchase
          ) {
            @if (thirdPartyDocLinkedCount != null) {
              <div>
                <span
                  class="ui-tag document-tag badge rounded-pill fw-normal mx-1"
                  (click)="navigateToDocumentList('quotes')"
                >
                  <i class="digi-out-checklist text-primary"></i>
                  {{
                    'Contact::Doc:CustomerQuotes'
                      | corePluralize: thirdPartyDocLinkedCount?.quotesCount
                  }}
                </span>
                <span
                  class="ui-tag document-tag badge rounded-pill fw-normal mx-1"
                  (click)="navigateToDocumentList('sales-purchases')"
                >
                  <i class="digi-out-delivery-box text-primary"></i>
                  {{
                    'Contact::Doc:SalesPurchases'
                      | corePluralize: thirdPartyDocLinkedCount?.salePurchasesCount
                  }}
                </span>
              </div>
            }
          }
        </div>
      }
    </div>
  </div>

  <document-side-panel-tags [entity]="entity"> </document-side-panel-tags>
  <ng-content select="[tags]"></ng-content>
  <div>
    @if (entity.isStockValidated) {
      @if (isStockValidatedWarning()) {
        <span class="ui-tag badge rounded-pill mx-1 bg-warning">
          {{ '::Validated' | abpLocalization }}
        </span>
      } @else {
        <span class="ui-tag badge rounded-pill mx-1 bg-success">
          {{ '::Validated' | abpLocalization }}
        </span>
      }
    }
    @if (
      !entity?.isClosed &&
      entity?.isDeliverable &&
      entity?.isDeliverable != Deliverable.NotDeliverable
    ) {
      <span
        class="ui-tag badge rounded-pill mx-1"
        [class]="entity?.isDeliverable == Deliverable.Deliverable ? 'bg-success' : 'bg-info'"
      >
        {{ '::Deliverable' | abpLocalization }}
      </span>
    }
    @if (!entity?.isClosed && entity?.isReserved && entity?.isReserved != Reserved.NotReserved) {
      <span
        class="ui-tag badge rounded-pill mx-1"
        [class]="entity?.isReserved == Reserved.Reserved ? 'bg-success' : 'bg-info'"
      >
        {{ '::Reserved' | abpLocalization }}
      </span>
    }
    @if (lastNotificationDate() != null) {
      <span class="ui-tag badge rounded-pill mx-1 bg-success">
        <i class="digi-out-send-email"></i>
        {{ lastNotificationDate() | date: 'short' }}
      </span>
    }
  </div>
}
@if (entity?.id) {
  <div class="my-2">
    <document-doc-hierarchy
      #docHierarchy
      [docId]="entity.id"
      [docService]="docService()"
    ></document-doc-hierarchy>
  </div>
  @if (productionLinkDtosObservable() != null) {
    <div class="my-2">
      <document-doc-link
        [docLinkDtosObservable]="productionLinkDtosObservable()"
        tooltip="Doc::Menu:ProductionFolderDocs"
      ></document-doc-link>
    </div>
  }
  @if (docLinkDtosObservable() != null) {
    <div class="my-2">
      <document-doc-link [docLinkDtosObservable]="docLinkDtosObservable()"></document-doc-link>
    </div>
  }
  @if (currentDocRole == docRole.CustomerSalesPurchase) {
    <div class="d-flex gap-2">
      @for (invoice of invoices$ | async; track $index) {
        <document-invoice-tag
          [invoice]="invoice"
          (clickEvent)="viewInvoice($event)"
        ></document-invoice-tag>
      }
    </div>
  }
}
@if (linePricingDetails != null) {
  <div class="container-amount my-1 py-1 px-2 rounded-2">
    <div class="my-0">
      <document-side-panel-explanations
        [id]="linePricingDetails.id"
        [title]="linePricingDetails.title"
        [explanations]="linePricingDetails.details"
      >
      </document-side-panel-explanations>
    </div>
  </div>
}
<ng-content></ng-content>
